function InputLabelText({ classes, styles, children }) {
  return (
    <label style={{ ...styles }} className={`Text-label ${classes}`}>
      {children}
    </label>
  );
}

export default InputLabelText;
